(() => {
  function init(root) {
    root.querySelectorAll('.td-marquee-row,.marquee-row').forEach(row => {
      if (row.dataset.ready) return;
      row.dataset.ready = 'true';
      const track = row.querySelector('.td-marquee-track,.marquee-track');
      const items = [...track.children];
      const group = document.createElement('div'); group.className = 'td-logo-group';
      items.forEach(item => group.appendChild(item)); track.appendChild(group);
      const duplicate = group.cloneNode(true); duplicate.setAttribute('aria-hidden','true'); duplicate.inert = true; track.appendChild(duplicate);
      const button = document.createElement('button'); button.type = 'button'; button.className = 'td-motion-control';
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = window.tdMotion ? !window.tdMotion.enabled() : preference.matches;
      function apply() {
        row.classList.toggle('td-is-paused',paused);
        button.setAttribute('aria-label', paused ? 'Play moving logos' : 'Pause moving logos');
        button.innerHTML = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">' +
          (paused ? '<path d="M3 1.5 10 6 3 10.5Z"/>' : '<path d="M2 1h3v10H2zm5 0h3v10H7z"/>') +
          '</svg><span>' + (paused ? 'Play' : 'Pause') + '</span>';
      }
      button.addEventListener('click',()=>{paused=!paused;apply()});
      preference.addEventListener('change',e=>{paused=e.matches;apply()});
      document.addEventListener('td:motion-change',()=>{paused=!window.tdMotion.enabled();apply()});
      row.after(button); apply();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
